'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _utils = require('../utils');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductAccordion = function ProductAccordion(el) {
  var _this = this;

  (0, _classCallCheck3.default)(this, ProductAccordion);

  var context = { context: el };

  this.els = {
    el: el,
    items: (0, _functional.getElements)('.js-Accordion_Item', context)
  };

  this.items = this.els.items.map(function (el) {
    var rv = {
      els: {
        container: el,
        opener: (0, _functional.getElement)('.js-Accordion_Opener', { context: el }),
        body: (0, _functional.getElement)('.js-Accordion_Body', { context: el })
      },
      _isOpen: el.getAttribute('aria-expanded') === 'true',
      getHeight: function getHeight() {
        var currentHeight = parseInt(window.getComputedStyle(this.els.body).height, 10);

        this.els.body.removeAttribute('style');
        var height = this.els.body.offsetHeight;

        this.els.body.style.height = currentHeight > 0 ? height + 'px' : currentHeight + 'px';

        return height;
      },

      get isOpen() {
        return this._isOpen;
      },
      set isOpen(val) {
        this._isOpen = val;

        this.els.container.setAttribute('aria-expanded', String(val));

        val ? (0, _utils.slideDown)(this.els.body, this.height) : (0, _utils.slideUp)(this.els.body, this.height);
      }
    };

    rv.height = rv.getHeight();

    return rv;
  });

  this.items.forEach(function (item) {
    item.els.opener.addEventListener('click', function () {
      item.isOpen = !item.isOpen;
    });
  });

  var resizeFnc = function resizeFnc() {
    _this.items.forEach(function (item) {
      return item.height = item.getHeight();
    });
  };
  window.addEventListener('resize', (0, _utils.debounce)(resizeFnc, 50));
};

exports.default = ProductAccordion;